import routerMixin from './router'
import { imgZip, imgCut } from '../filters/ossImg'
import { GetQueryString } from 'lib/tools/utils'

export default {
  mixins: [routerMixin],
  filters: {
    imgZip,
    imgCut
  },
  methods: {
    commonToAdPage(obj) {
      // 前置钩子，可以用来埋点
      if (typeof obj.beforeExec === 'function') {
        obj.beforeExec()
      }
      // 需要运营手动配置hidenav参数隐藏头部
      const hideNavigationBar = GetQueryString('hidenav', obj.url)
      const { isYixinliApp, isZiXunApp } = this.$platform

      // 不能使用routePush，一些广告位测试需要跳转到线上
      if (isYixinliApp || isZiXunApp) {
        let isOpenWebview = true
        if (
          obj.url.indexOf('yixinli://') === 0 ||
          obj.url.indexOf('muse://') === 0
        ) {
          isOpenWebview = false
        }
        // 如果是http协议用openWebView打开页面，如果是原生协议则用window.location.href
        if (isOpenWebview) {
          this.$bridge.openWebView({
            url: obj.url,
            isCurrentPageOpen: 0,
            hideNavigationBar: hideNavigationBar ? 1 : 0
          })
        } else {
          window.location.href = obj.url
        }
      } else {
        if (obj.path) {
          this.$router.push(obj.path)
        } else {
          window.location.href = obj.url
        }
      }
    },
    toFixed(num) {
      return num > 10 ? num : '0' + num
    },
    /**
     * 格式化时间
     * @param {number} t
     */
    parseTime(t) {
      const day = parseInt(t / parseInt(1000 * 60 * 60 * 24))
      t = t % parseInt(1000 * 60 * 60 * 24)
      const hour = parseInt(t / parseInt(1000 * 60 * 60))
      t = t % parseInt(1000 * 60 * 60)
      const min = parseInt(t / parseInt(1000 * 60))
      t = t % parseInt(1000 * 60)
      const sec = parseInt(t / parseInt(1000))
      return { day, hour, min, sec }
    }
  }
}
